import type React from 'react';
import { createContext, useState, useContext, type Dispatch, type SetStateAction } from 'react';
import type { WorkoutType } from './util';

type WorkoutDataContextType = {
  workout?: WorkoutType;
  setWorkout: Dispatch<SetStateAction<WorkoutType | undefined>>;
};

const WorkoutDataContext = createContext<WorkoutDataContextType | undefined>(undefined);

export const WorkoutDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [workout, setWorkout] = useState<WorkoutType | undefined>();

  return <WorkoutDataContext.Provider value={{ workout, setWorkout }}>{children}</WorkoutDataContext.Provider>;
};

export const useWorkoutDataContext = (): WorkoutDataContextType => {
  const context = useContext(WorkoutDataContext);
  if (!context) {
    throw new Error('useWorkoutDataContext must be used within a WorkoutDataProvider');
  }
  return context;
};
